import {Injectable} from '@angular/core';
import {Loading, LoadingController} from "ionic-angular";

/*
  Generated class for the LoadingServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingServiceProvider {

  private loader: Loading;

  constructor(private loadingController: LoadingController) {
  }

  public present(message?: string): Loading {
      this.loader = this.loadingController.create({
        content: message || 'Bitte warten...'
      });
      this.loader.present();
      return this.loader;
  }

  public dismiss(): void {
    if(this.loader){
      this.loader.dismissAll();
      this.loader = null;
    }

    console.log('loading dismiss all');
  }

}



// WEBPACK FOOTER //
// ./src/providers/loading-service/loading-service.ts